module.exports = __webpack_public_path__ + "static/media/Marriott-Karamo.44d26081.jpg";